import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'myFilter'
})
export class MyFilterPipe implements PipeTransform {

  transform(items: any[],keyword: any): any[] {
    if (!items) return [];
    
    return items.filter(item=>{
      
      if(item['label'].toLowerCase().indexOf(keyword.toLowerCase()) !== -1){
        return true
      } 
    })
    

  }
}